var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServiceRequestCardImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.6938 13.9592L20.6938 3.95921C20.4883 3.82216 20.2469 3.74902 20 3.74902C19.7531 3.74902 19.5117 3.82216 19.3062 3.95921L4.30625 13.9592C4.13502 14.0735 3.99465 14.2282 3.89761 14.4098C3.80057 14.5913 3.74987 14.794 3.75 14.9998V31.2498C3.75 31.9129 4.01339 32.5488 4.48223 33.0176C4.95107 33.4864 5.58696 33.7498 6.25 33.7498H33.75C34.413 33.7498 35.0489 33.4864 35.5178 33.0176C35.9866 32.5488 36.25 31.9129 36.25 31.2498V14.9998C36.2501 14.794 36.1994 14.5913 36.1024 14.4098C36.0054 14.2282 35.865 14.0735 35.6938 13.9592ZM15.1125 23.7498L6.25 29.9998V17.4264L15.1125 23.7498ZM17.6703 24.9998H22.3297L31.1781 31.2498H8.82187L17.6703 24.9998ZM24.8875 23.7498L33.75 17.4264V29.9998L24.8875 23.7498ZM20 6.5014L32.7984 15.0342L22.3297 22.4998H17.6734L7.20469 15.0342L20 6.5014Z",
    fill: "#9E874A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceRequestCardImage);
export default __webpack_public_path__ + "static/media/ServiceRequestCardImage.def9096a42b4d16b5bd46f34f93702f2.svg";
export { ForwardRef as ReactComponent };